import { ValidatorRuleType } from "@tCooneyBrothers/Common/Utilities/validate";

export const intialErrorFormState = {
    firstName: "",
    email: "",
    // company: "",
    comments: "",
};

export interface ValidatorConfigType {
    [key: string]: ValidatorRuleType;
}

export interface FormErrorsStateType {
    [key: string]: string | undefined;
}

export const customReportIssueValidatorConfig: ValidatorConfigType = {
    firstName: {
        required: true,
        minLength: 2,
        label: "Name",
    },
    email: {
        required: true,
        regex: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
        label: "Email Address",
    },
    // company: {
    //     required: true,
    //     minLength: 2,
    //     label: "Company",
    // },
    comments: {
        required: true,
        minLength: 2,
        label: "Comments",
    },
};
